import React, { useEffect, useState, useRef } from "react";
import { Button, Form, Input, Modal, Radio } from "antd";
import classnames from 'classnames'
import styles from "./index.module.less";

const ModalTitle = () => {
    return(
        <div className="confirm-header">
            <img src="https://p5.ssl.qhimg.com/t011ec52c575edc6084.png"></img>
            <span>360软管联运平台</span>
        </div>
    )
}
const ModalFooter = ({onClose, onOk}) => {
    return (
        <div className="confirm-footer">
            <div onClick={onClose} style={{marginRight: 8, cursor: 'pointer'}}>取消</div>
            <div onClick={onOk} style={{cursor: 'pointer'}}>确定</div>
        </div>
    )
}
const ConfirmModal = ({open,onOk, onClose, title}) => {
  return (
    <Modal
      className="ConfirmModal"
      title={<ModalTitle></ModalTitle>}
      open={open}
      onOk={() => onOk?.()}
      onCancel={() => onClose?.()}
      footer={<ModalFooter onOk={onOk} onClose={onClose}></ModalFooter>}
    //   styles={modalStyles}
    >
      <div className="confirm-content">
        <img src="https://p2.ssl.qhimg.com/t015caf12dd9bdcde25.png" ></img>
        <p>{`你确定要下架${title}吗？`}</p>
      </div>
    </Modal>
  );
};

export default ConfirmModal;
